import { render } from "./Werkstudent.vue?vue&type=template&id=ab66f0e4&scoped=true"
import script from "./Werkstudent.vue?vue&type=script&lang=js"
export * from "./Werkstudent.vue?vue&type=script&lang=js"

import "./Werkstudent.vue?vue&type=style&index=0&id=ab66f0e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab66f0e4"]])

export default __exports__